import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCerrar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		id: "cerrar",
		d: "M16,32A16,16,0,0,1,4.686,4.685a16,16,0,0,1,22.628,22.63A15.9,15.9,0,0,1,16,32ZM16,2A14,14,0,0,0,6.1,25.9,14,14,0,1,0,25.9,6.1,13.907,13.907,0,0,0,16,2ZM11.027,21.982a1.007,1.007,0,0,1-.713-1.722l4.266-4.27-4.236-4.23a1,1,0,1,1,1.414-1.42l4.236,4.24,4.3-4.3a1.009,1.009,0,0,1,1.425,1.43l-4.3,4.3,4.236,4.23a1,1,0,1,1-1.415,1.42l-4.236-4.24L11.74,21.69A1.006,1.006,0,0,1,11.027,21.982Z",
		fill: "#d7373f"
	})]
});
const ForwardRef = forwardRef(SvgCerrar);
export { ForwardRef as ReactComponent };
